const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  GTM_ID: process.env.REACT_APP_GTM_ID,
  STATIC_URL: process.env.REACT_APP_STATIC_URL,
  REACT_ENV: process.env.REACT_APP_REACT_ENV,
};

export default config;